<template>
  <CModal
    :show="true"
    :closeOnBackdrop="false"
    :centered="true"
    color="danger"
  >
    <template #header>
      <h5 class="mb-0">{{ title }}</h5>
    </template>

    <div v-if="phase === 'running' || phase === 'checking'">
      <ul class="list-unstyled mb-3">
        <li
          v-for="(step, index) in steps"
          :key="step.label"
          class="d-flex align-items-center mb-2"
          :class="{
            'font-weight-bold': index === currentStep,
            'text-muted': index > currentStep,
          }"
        >
          <em
            class="mr-2"
            :class="
              index < currentStep
                ? 'fas fa-check-circle text-success'
                : index === currentStep
                ? 'fas fa-circle-notch fa-spin text-primary'
                : 'far fa-circle'
            "
          ></em>
          {{ step.label }}
        </li>
      </ul>
      <p v-if="phase === 'checking'" class="mb-0">
        No answer from the server yet - checking what happened…
      </p>
      <p v-else class="mb-0 text-muted">
        Don't close this page · can't be cancelled once started
      </p>
    </div>

    <CAlert v-else-if="phase === 'success'" color="success" class="mb-0">
      {{ message }}
    </CAlert>

    <div v-else-if="phase === 'unknown'">
      <p class="mb-2">{{ message }}</p>
      <p v-if="activeDatabase" class="mb-1">
        Active database: <strong>{{ activeDatabase }}</strong>
      </p>
      <p v-if="lastSwitch" class="mb-0">
        Last switch: {{ lastSwitch.fromDatabase }} → {{ lastSwitch.toDatabase }},
        <strong>{{ lastSwitch.result }}</strong>
        <span v-if="lastSwitch.detail"> - {{ lastSwitch.detail }}</span>
      </p>
    </div>

    <template #footer>
      <CButton
        v-if="phase === 'success'"
        color="primary"
        @click="$emit('login-again')"
        >Log in again</CButton
      >
      <CButton v-else-if="phase === 'unknown'" color="secondary" @click="$emit('close')"
        >Close</CButton
      >
      <span v-else></span>
    </template>
  </CModal>
</template>

<script>
// Shown while the switch POST is outstanding. The backend does these in order but reports no
// progress, so the steps move on by elapsed time (seconds each one starts at).
const STEPS = [
  { label: "Stopping new requests (about 6 s)", startsAt: 0 },
  { label: "Waiting for running work to finish (up to 30 s)", startsAt: 6 },
  { label: "Switching the database", startsAt: 12 },
  { label: "Bringing the system back (about 6 s)", startsAt: 14 },
];

export default {
  name: "DbSwitchProgress",
  props: {
    target: { type: String, required: true },
    // running | checking (no answer, looking at the status) | success | unknown
    phase: { type: String, required: true },
    message: { type: String, default: "" },
    activeDatabase: { type: String, default: "" },
    lastSwitch: { type: Object, default: null },
  },
  data() {
    return { steps: STEPS, elapsed: 0, timer: null };
  },
  computed: {
    currentStep() {
      if (this.phase === "success") return STEPS.length;
      let step = 0;
      STEPS.forEach((s, index) => {
        if (this.elapsed >= s.startsAt) step = index;
      });
      return step;
    },
    title() {
      if (this.phase === "success") return `Switched to ${this.target}`;
      if (this.phase === "unknown") return "Switch result";
      const minutes = Math.floor(this.elapsed / 60);
      const seconds = String(this.elapsed % 60).padStart(2, "0");
      return `Switching to ${this.target} … ${minutes}:${seconds}`;
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.phase === "running" || this.phase === "checking") this.elapsed += 1;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
